import React, { useState, useEffect } from 'react';
import { Play, Pause } from 'lucide-react';
import './Timer.css';

function Timer({ time, isRunning, setIsRunning, onTimeChange, isEditing, nightMode, compact }) {
  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const [editableTime, setEditableTime] = useState(formatTime(time));

  useEffect(() => {
    setEditableTime(formatTime(time));
  }, [time]);

  const handleTimeChange = (e) => {
    setEditableTime(e.target.value);
  };

  const handleTimeBlur = () => {
    const [hours, minutes, seconds] = editableTime.split(':').map(Number);
    if ([hours, minutes, seconds].some((part) => Number.isNaN(part))) {
      setEditableTime(formatTime(time));
      return;
    }
    const newTime = hours * 3600 + minutes * 60 + seconds;
    onTimeChange(newTime);
  };

  return (
    <div className={`timer ${compact ? 'timer-compact' : ''} ${nightMode ? 'night-mode' : ''}`}>
      {!compact && <span className="timer-label">Match clock</span>}
      {isEditing ? (
        <input
          type="text"
          value={editableTime}
          onChange={handleTimeChange}
          onBlur={handleTimeBlur}
          className="timer-input"
          aria-label="Match time"
        />
      ) : (
        <div className="timer-display">{formatTime(time)}</div>
      )}
      <button className={`timer-button ${isRunning ? 'is-running' : ''}`} onClick={() => setIsRunning(!isRunning)}>
        {isRunning ? <Pause size={14} /> : <Play size={14} />}
        {!compact && (isRunning ? 'Pause' : 'Start')}
      </button>
    </div>
  );
}

export default Timer;
